// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import {
    GetOrderAwaitingApprovalApiParameter,
    OrderAwaitingApprovalCollectionModel,
    OrderAwaitingApprovalModel,
} from "@guestsupply/App/Services/CustomerOrderAwaitingApprovalService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { DataViewState, setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface OrderAwaitingApprovalsState extends DataViewState<OrderAwaitingApprovalModel> {}

const initialState: OrderAwaitingApprovalsState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const reducer = {
    "Data/OrderApprovals/BeginLoadingOrderAwaitingApproval": (
        draft: Draft<OrderAwaitingApprovalsState>,
        action: { parameter: GetOrderAwaitingApprovalApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },
    "Data/OrderApprovals/CompleteLoadingOrderAwaitingApproval": (
        draft: Draft<OrderAwaitingApprovalsState>,
        action: {
            parameter: GetOrderAwaitingApprovalApiParameter;
            collection: OrderAwaitingApprovalCollectionModel;
        },
    ) => {
        setDataViewLoaded(draft, action.parameter, action.collection, collection => collection.customerOrderApprovals!);
    },
};

const xOrderAwaitingApproval = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xOrderAwaitingApproval = xOrderAwaitingApproval;

export type xOrderAwaitingApprovalState = {
    xOrderAwaitingApproval: OrderAwaitingApprovalsState;
} & ApplicationState;

type xOrderAwaitingApprovalsStateReducers = {
    orderAwaitingApprovals: typeof xOrderAwaitingApproval;
};

export type xOrderAwaitingApprovalsStateActions =
    | Parameters<xOrderAwaitingApprovalsStateReducers[keyof xOrderAwaitingApprovalsStateReducers]>[1]
    | AnyAction;
